import React from 'react';
import { Box, Typography, Card, CardContent } from '@mui/material';
import { FaUserPlus, FaExchangeAlt } from 'react-icons/fa';

const ATTACHMENT_TYPES = {
  ATTACH: 'attach',
  TRANSFER: 'transfer'
};

const AttachmentTypeSelection = ({ selectedType, onTypeSelect }) => {
  const options = [
    {
      type: ATTACHMENT_TYPES.ATTACH,
      icon: FaUserPlus,
      title: 'Attach',
      description: 'Add a new individual as a full-time member of this project, with a dedicated representative.'
    },
    {
      type: ATTACHMENT_TYPES.TRANSFER,
      icon: FaExchangeAlt,
      title: 'Assign Temporarily',
      description: 'Temporarily assign an individual from another Business Unit to contribute to this project.'
    }
  ];

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Typography variant="subtitle1" gutterBottom>
        Select Attachment Type
      </Typography>
      <Box sx={{ display: 'flex', gap: 2 }}>
        {options.map((option) => {
          const Icon = option.icon;
          const isSelected = selectedType === option.type;

          return (
            <Card
              key={option.type}
              onClick={() => onTypeSelect(option.type)}
              elevation={0}
              sx={{
                flex: 1,
                cursor: 'pointer',
                border: isSelected ? '2px solid #2563EB' : '1px solid #E2E8F0',
                backgroundColor: isSelected ? '#EFF6FF' : '#FFFFFF',
                borderRadius: '8px',
                transition: 'all 0.2s ease',
                '&:hover': {
                  borderColor: '#2563EB',
                  backgroundColor: isSelected ? '#EFF6FF' : '#F8FAFC'
                }
              }}
            >
              <CardContent sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
                p: 3
              }}>
                <Box
                  sx={{
                    width: 48,
                    height: 48,
                    borderRadius: '50%',
                    backgroundColor: isSelected ? '#2563EB' : '#E2E8F0',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    mb: 2,
                    transition: 'all 0.2s ease'
                  }}
                >
                  <Icon
                    size={20}
                    color={isSelected ? '#FFFFFF' : '#64748B'}
                  />
                </Box>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 600,
                    color: isSelected ? '#2563EB' : '#1E293B',
                    mb: 1
                  }}
                >
                  {option.title}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: '#64748B',
                    lineHeight: 1.5
                  }}
                >
                  {option.description}
                </Typography>
              </CardContent>
            </Card>
          );
        })}
      </Box>
    </Box>
  );
};

export { ATTACHMENT_TYPES };
export default AttachmentTypeSelection;
